module.exports = __webpack_public_path__ + "static/media/інпрофіт-модернізація-систем-обробки-зерна_w_200.28b3ab16.jpg";